/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import statusoftminindia from '../public/statusoftminindia.pdf';
import { showLoading } from 'react-global-loading';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class StatusInIndia extends React.Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    showLoading(false);
  }

  render() {

    return (
      <div className="container">
        <embed src={statusoftminindia} width="100%" height="600px" />
      </div>
    );
  }
}
export default StatusInIndia;